{
  "Approve": "Genehmigen",
  "DeleteReminder": "Erinnerung löschen",
  "DismissAlert": "Verwerfen",
  "DismissReminder": "Erinnerung verwerfen",
  "EditReminder": "Erinnerung bearbeiten",
  "High": "Hoch",
  "Reject": "Ablehnen",
  "RemindMe15Min": "Erinnere mich in 15 Minuten",
  "RemindMe5Min": "Erinnere mich in 5 Minuten",
  "RemindMe60Min": "Erinnere mich in einer Stunde",
  "RemindMeTomorrow": "Erinnere mich morgen",
  "Snooze": "Erinnern",
  "markAsRead": "Als gelesen markieren",
  "markAsUnread": "Als ungelesen markieren"
}
